import moment from 'moment'

function buildPartyForAllocation ({party, passengers = [], features, departureStartDate}) {
  const teenagersAllocationPolicy = features && features.childrenAllocationPolicy && features.childrenAllocationPolicy.teenagers
  const teenagers = passengers.reduce((acc, passenger) => {
    if (passenger.type === 'child') {
      const age = moment(departureStartDate.date).diff(passenger.dateOfBirth, 'years')
      const isTeenager = teenagersAllocationPolicy &&
        age >= teenagersAllocationPolicy.ageFrom &&
        age <= teenagersAllocationPolicy.ageTo

      if (isTeenager) {
        return acc + 1
      }
    }
    return acc
  }, 0)

  return {
    adults: party.adults,
    children: party.children - teenagers,
    teenagers,
  }
}

export default buildPartyForAllocation
